"use client";

import Script from "next/script";
import { useEffect, useState } from "react";

export default function Snipcart() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // Setting global settings ensures the API key is found 
    // even if the script loads before the div is fully rendered.
    (window as any).SnipcartSettings = {
      publicApiKey: "NTkzMDljYWEtMTY4NS00NmU1LTgzYjItMGFmZmJmZDI2MTU0NjM5MDE0MDYxMDEzNjQ1ODUz",
      modalStyle: "side",
    };
    setMounted(true);
  }, []);

    useEffect(() => {
        (window as any).SnipcartSettings = {
        publicApiKey: "NTkzMDljYWEtMTY4NS00NmU1LTgzYjItMGFmZmJmZDI2MTU0NjM5MDE0MDYxMDEzNjQ1ODUz",
        modalStyle: "side",
        templatesUrl: "/snipcart-templates.html", 
        };
        setMounted(true);
    }, []);

  if (!mounted) return null;

  return (
    <>
      <link 
        rel="stylesheet" 
        href="https://cdn.snipcart.com/themes/v3.2.0/default/snipcart.css" 
      />

      {/* 2. Snipcart Hidden Div */}
      <div
        hidden
        id="snipcart"
        data-api-key="NTkzMDljYWEtMTY4NS00NmU1LTgzYjItMGFmZmJmZDI2MTU0NjM5MDE0MDYxMDEzNjQ1ODUz"
        data-config-modal-style="side"
      ></div>

      {/* 3. Correct Absolute JS Path */}
      <Script
        src="https://cdn.snipcart.com/themes/v3.2.0/default/snipcart.js"
        strategy="afterInteractive"
      />
    </>
  );
}
